import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import * as DOMPurify from 'dompurify';
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import { myUtilities } from "../../Utils";

class CreditCardPaymentConvenienceFeeContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sendToDIPage: false,
    };
  }
  onClickYes = () => {
    this.setState({
      sendToDIPage: true,
    });
  };
  onClickNo = (data) => {
    data.setCreditCardCheck(false);
  };
  render() {
    if (!this.state.sendToDIPage)
      return (
        <Subscribe to={[PaymentDataContainer]}>
          {(data) => (
            <Container>
              <Row>
                <Col>
                  {myUtilities.accountSpecificLanguage('CreditCard.Message.AdditionalAmount',
                  'You\'ll be charged an additional amount of')}
                  {this.props.totalConvienceFee}. {myUtilities.accountSpecificLanguage(
                    'generic.Message.Continue',
                    'Continue'
                  )}?
                  <button onClick={this.onClickYes}>
                    {myUtilities.accountSpecificLanguage(
                      'generic.Message.Yes',
                      'Yes'
                    )}
                  </button>
                  <button
                    onClick={() => {
                      this.onClickNo(data);
                    }}
                  >
                    {myUtilities.accountSpecificLanguage(
                      'generic.Message.No',
                      'No'
                    )}
                  </button>
                </Col>
              </Row>
            </Container>
          )}
        </Subscribe>
      );
    else return null;
  }
}

export default CreditCardPaymentConvenienceFeeContent;
